import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconTransactionComponent } from "./med-icon-transaction.component";

@NgModule({
  declarations: [
    MedIconTransactionComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconTransactionComponent,
  ],
})
export class MedIconTransactionModule { }
